import { SiteLog } from '../../../constants/SiteLogs';
import { formatHoursMinutes } from '../../helpers/dateFormatters';
import { ShortDay, shortDays } from '../../helpers/dateUtilities';

export type DaySiteLogEntry = Partial<Record<ShortDay, TypeSiteLogEntry>>;
export type TypeSiteLogEntry = SiteLog[];

const buildLogsEntry = (day: ShortDay, logs: DaySiteLogEntry): string => {
	const dayLogs = logs[day];
	if (dayLogs === undefined) {
		return '';
	} else {
		return dayLogs.reduce((totalEntry, inLog) => {
			const outLog = inLog.out;
			const outLogValue =
				outLog !== null
					? `${formatHoursMinutes(outLog.dateTime.toDate())}`
					: '';
			const row =
				formatHoursMinutes(inLog.in.dateTime.toDate()) +
				'-' +
				outLogValue;
			return totalEntry + row + ' ';
		}, '');
	}
};

type RowData = [
	{ name: string; mobileNumber: string },
	{ name: string; mobileNumber: string },
	string,
	string,
	string,
	DaySiteLogEntry,
	DaySiteLogEntry,
	DaySiteLogEntry,
	DaySiteLogEntry,
	DaySiteLogEntry,
	DaySiteLogEntry,
	DaySiteLogEntry,
];

/**
 * Because of how we build the table body renders this is an absolute bastard,
 * add a new column and this will break
 * @param data The data row
 * @returns modified csv row data as strings for csv export
 */
export const siteLogReportCSVBody = (
	data: {
		index: number;
		data: RowData;
	}[],
): {
	index: number;
	data: string[];
}[] => {
	return data.map((row) => {
		const [col1, col2, col3, col4, col5, ...logs] = row.data;

		return {
			index: row.index,
			data: [
				col1.name,
				col2.mobileNumber,
				col3,
				col4,
				col5,
				...shortDays.map((day) => buildLogsEntry(day, logs[0])),
			],
		};
	});
};

export const siteLogCustomSearch = (
	searchString: string,
	data: RowData,
): boolean => {
	const [col1, col2, col3, col4, col5, ...logs] = data;
	const simpleRow = [
		col1.name,
		col2.mobileNumber,
		col3,
		col4,
		col5,
		...shortDays.map((day) => buildLogsEntry(day, logs[0])),
	];
	return simpleRow.some((value) => value.includes(searchString));
};
